/* ag-cart-feedback v1 — reactive add-to-cart / cart-count feedback.
   Subscribes to the theme's existing MinimogEvents pub/sub only for the
   success animation. The grok-func block below OBSERVES /cart/add responses
   (it does not rewrite requests) because product-form.js swallows non-JSON
   bodies with console.error only. Removal: delete this file + its tags. */
(function () {
  'use strict';
  if (window.__agCartFeedback) return;
  window.__agCartFeedback = true;

  var ATC_SELECTOR = 'button[name="add"].add-to-cart';
  var COUNT_SELECTOR = '.cart-count,[class*="cart-count"],[data-cart-count]';
  var successTimers = new WeakMap();

  function markAdded() {
    document.querySelectorAll(ATC_SELECTOR).forEach(function (btn) {
      var rect = btn.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return; // hidden instances
      btn.classList.add('ag-atc-success');
      var prev = successTimers.get(btn);
      if (prev) clearTimeout(prev); // interruptible: rapid re-adds restart cleanly
      successTimers.set(btn, setTimeout(function () {
        btn.classList.remove('ag-atc-success');
        successTimers.delete(btn);
      }, 1600));
    });
  }

  function bumpCounts() {
    document.querySelectorAll(COUNT_SELECTOR).forEach(function (el) {
      el.classList.remove('ag-count-bump');
      void el.offsetWidth; // restart the animation
      el.classList.add('ag-count-bump');
      el.addEventListener('animationend', function handler() {
        el.classList.remove('ag-count-bump');
        el.removeEventListener('animationend', handler);
      });
    });
  }

  function wire(events) {
    try {
      events.subscribe('ON_ITEM_ADDED', function () {
        markAdded();
        bumpCounts();
      });
      events.subscribe('ON_CART_UPDATE', bumpCounts);
      events.subscribe('ON_FOX_CART_UPDATE', bumpCounts);
    } catch (e) { /* pub/sub shape changed — degrade to nothing */ }
  }

  // MinimogEvents may register after us; poll briefly, then give up silently.
  var tries = 0;
  (function waitForEvents() {
    if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
      wire(window.MinimogEvents);
      return;
    }
    if (++tries < 40) setTimeout(waitForEvents, 250); // up to ~10s
  })();
})();

/* grok-func: when the sticky ATC is up, the tab bar is translated off-screen
   and pointer-events:none, but it stays in the tab order (measured: Home /
   Find car / Search / Cart at y=859 in a 844px viewport). Mirror the visual
   handshake with inert so keyboard users cannot land on those controls. */
(function () {
  'use strict';
  if (window.__agTabbarStickyInert) return;
  window.__agTabbarStickyInert = true;

  function sync() {
    var tab = document.querySelector('.ag-tabbar-shell');
    if (!tab) return;
    var stickyOn = !!document.querySelector('.agpe-sticky.agpe-sticky--on');
    if (stickyOn) {
      tab.setAttribute('inert', '');
      tab.setAttribute('aria-hidden', 'true');
    } else {
      tab.removeAttribute('inert');
      if (tab.getAttribute('aria-hidden') === 'true') tab.removeAttribute('aria-hidden');
    }
  }

  function bind() {
    sync();
    var bar = document.querySelector('.agpe-sticky');
    if (bar && !bar.__agTabbarInertBound) {
      bar.__agTabbarInertBound = true;
      try { new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class', 'hidden'] }); }
      catch (e) {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  window.setTimeout(bind, 800);
  window.setTimeout(bind, 2500);
})();

/* grok-func: product-form.js POSTs to /cart/add (no .js). A HTML/429 body makes
   response.json() throw, the catch is console.error, and the shopper sees the
   button snap back with no message. Observe only; never alter the request. */
(function () {
  'use strict';
  if (window.__agAtcFailGuard) return;
  window.__agAtcFailGuard = true;

  var FAIL_MSG = 'That item could not be added to your cart. Please try again in a few minutes, or WhatsApp us if it keeps happening.';

  function visibleNotification() {
    var nodes = document.querySelectorAll('.prod__form-error .notification, .notification.show, .notification.warning');
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 8) return true;
    }
    return false;
  }

  function showFail(message) {
    if (visibleNotification()) return;
    var host = document.querySelector('.prod__form-error');
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!host && form && form.parentNode) host = form.parentNode;
    if (!host) return;
    var el = document.querySelector('.ag-atc-fail');
    if (!el) {
      el = document.createElement('p');
      el.className = 'ag-atc-fail';
      el.setAttribute('role', 'alert');
      host.appendChild(el);
    }
    el.hidden = false;
    el.textContent = message || FAIL_MSG;
  }

  var orig = window.fetch;
  if (typeof orig !== 'function' || orig.__agAtcFailGuard) return;
  var wrapped = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0]
      : (arguments[0] && arguments[0].url) || '';
    var method = (arguments[1] && arguments[1].method) ||
      (arguments[0] && arguments[0].method) || 'GET';
    var res = orig.apply(this, arguments);
    try {
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && String(method).toUpperCase() === 'POST') {
        res.then(function (r) {
          var ct = (r.headers && r.headers.get && r.headers.get('content-type')) || '';
          var bad = !r.ok || /text\/html/i.test(ct);
          if (!bad) return;
          window.setTimeout(function () {
            if (!visibleNotification()) showFail(FAIL_MSG);
          }, 700);
        }).catch(function () {
          window.setTimeout(function () {
            if (!visibleNotification()) showFail(FAIL_MSG);
          }, 700);
        });
      }
    } catch (e) {}
    return res;
  };
  wrapped.__agAtcFailGuard = true;
  wrapped.__agUxcObserved = orig.__agUxcObserved;
  window.fetch = wrapped;
})();
